import { render, staticRenderFns } from "./ChatGroupDetails.vue?vue&type=template&id=54f4179f&"
import script from "./ChatGroupDetails.vue?vue&type=script&lang=js&"
export * from "./ChatGroupDetails.vue?vue&type=script&lang=js&"
import style0 from "./ChatGroupDetails.vue?vue&type=style&index=0&id=54f4179f&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports